import React from 'react';
import { Route } from 'react-router-dom';
import ErrorBoundary from 'components/ErrorBoundary';

const RouteWithSubRoutes = (route = [], isWithoutDealer = false) => {
  return (
    <ErrorBoundary>
      <Route
        {...route}
        render={props => {
          return (
            <route.Component
              {...props}
              isWithoutDealer={isWithoutDealer}
              routes={route.routes}
            />
          );
        }}
      />
    </ErrorBoundary>
  );
};
export default RouteWithSubRoutes;
